import {
  CommonHelper as AuthHelper,
  CommonHelper,
  LoginFrom,
  usePTVNAuthentication,
  CookieName as Cookie,
} from '@ptvn-react/authentication';
import { AES } from 'crypto-js';
import Cookies from 'js-cookie';
import React, { useState, useEffect } from 'react';
import { Dropdown } from 'react-bootstrap';
import { IntegrationClient } from '../../api/IntegrationClient';
import APIConstant from '../../utils/constants/APIConstant';
import { CookieName, GA4TrackConstant } from '../../utils/constants/CommonConstants';
import { useModalStack } from '../modal/ModalStackProvider';
import { SomethingWentWrongModal } from '../modal/SomethingWentWrongModal';
import EPLogo from '../../../assets/images/thumbnail/logo-ep.svg';
import OPLogo from '../../../assets/images/thumbnail/logo-op.png';
import PTVNLogo from '../../../assets/images/thumbnail/history_logo_01.png';
import OnePlanetLogo from '../../../assets/images/thumbnail/logo-oneplanet.svg';
import SWWLogo from '../../../assets/images/thumbnail/logo-sww.svg';
import environment from 'environment';
import { GatewayGraphQLClient } from '../../api/GatewayGraphQLClient';
import { useProviderIdpLazyQuery } from '../../graphql/autogenerate/hooks';
import { useEMarketplaceLayoutContext } from './EMarketplaceLayoutContext';
import GA4Helper from '../../utils/helpers/GA4Helper';
import urljoin from 'url-join';
import PageRoute from '../../utils/constants/PageRoute';
import { useTranslation } from 'react-i18next';
import { useHistory, useLocation } from 'react-router';
import { UserRoleType } from '../../utils/constants/JobBoardConstants';
import { ExtendedUserInformation } from '../../models/User';
import { ConfirmModal } from '../modal/ConfirmModal';
import { ModalSize } from '../../utils/constants/StyleConstant';
import { UserRole } from '../../pages/PI/Contants/role';

const url = APIConstant.supplierConnect.redirect;

interface LoginAsItem {
  logo: any;
  label: string;
  loginUrl: string;
}

export default function AppSwitcher(
  props: React.PropsWithChildren<any>,
): React.FunctionComponentElement<any> {
  const { isTabletSize, role } = useEMarketplaceLayoutContext();
  const { tenantID, graphQLProviderIdp, renderLink, redirectToPrevSite, elementID } =
    useAppSwitcher(isTabletSize);
  const { t } = useTranslation();
  const location = useLocation();
  const history = useHistory();
  const isPIService = location.pathname.includes(PageRoute.PI);
  const isSubscriptionService = location.pathname.includes(PageRoute.SUBSCRIPTION_PLAN);
  const { extendedUserInformation } = usePTVNAuthentication<ExtendedUserInformation>();

  const [userRole, setUserRole] = useState<UserRoleType>();

  const { push } = useModalStack();

  useEffect(() => {
    setUserRole(extendedUserInformation?.companies[0]?.roles[0]?.roleName || UserRole.SUPPLIER);
  }, [extendedUserInformation?.companies[0]?.roles[0]?.roleName || UserRole.SUPPLIER]);

  const loginAsBuyerList: LoginAsItem[] = [
    {
      logo: OnePlanetLogo,
      label: 'One Planet',
      loginUrl: `${environment.oneplanetLogin}`,
    },
    {
      logo: EPLogo,
      label: 'e-Procurement',
      loginUrl: `${environment.epLogin}`,
    },
    // {
    //   logo: OPLogo,
    //   label: "Online Purchasing",
    //   loginUrl: `${environment.opLogin}`,
    // },
  ];

  const getLoginAsList = () => {
    switch (userRole) {
      case UserRoleType.SUPPLIER:
        return loginAsBuyerList;
      case UserRoleType.BUYER:
      default:
        return undefined;
    }
  };

  const onClickLoginAs = (loginUrl: string) => {
    const wording =
      userRole === UserRoleType.BUYER
        ? {
            title: 'Layout.LoginAs.ConfirmLoginAsSupplierModal.Title',
            description: 'Layout.LoginAs.ConfirmLoginAsSupplierModal.Description',
            confirmMessage: 'Layout.LoginAs.ConfirmLoginAsSupplierModal.ConfirmMessage',
          }
        : {
            title: 'Layout.LoginAs.ConfirmLoginAsBuyerModal.Title',
            description: 'Layout.LoginAs.ConfirmLoginAsBuyerModal.Description',
            confirmMessage: 'Layout.LoginAs.ConfirmLoginAsBuyerModal.ConfirmMessage',
          };

    push(ConfirmModal, {
      data: {
        modalSize: ModalSize.MD,
        title: t(wording.title),
        submitText: t('Common.Button.OK'),
        cancelText: t('Common.Button.Cancel'),
      },
      onClose: () => {},
      onSubmit: () => {
        const loginFrom: LoginFrom = {
          clientID: '',
          fallbackURL: '',
          logoutURL: loginUrl,
        };

        Cookies.set(
          Cookie.USER_SUBJECT_CHECKING,
          AuthHelper.encodeToStorage(JSON.stringify(loginFrom)),
        );
        history.push(PageRoute.LOGOUT);
      },
      children: (
        <>
          <span>{t(wording.description)}</span>
          <br />
          <br />
          <span>{t(wording.confirmMessage)}</span>
        </>
      ),
    });
  };

  return (tenantID || graphQLProviderIdp?.provider?.providerGroup) && extendedUserInformation ? (
    <Dropdown className="smp-none">
      <Dropdown.Toggle
        id="pi-header-btn-app-switcher"
        as="button"
        bsPrefix="btn btn-circle"
        type="button"
      >
        <i className="icon-lg-app1"></i>
      </Dropdown.Toggle>
      <Dropdown.Menu alignRight style={{ width: 'unset', maxWidth: 'unset' }}>
        <div className="dropdown-list">
          <small className="mt-4px mb-4px ml-2 mr-2">
            {userRole === UserRoleType.BUYER ? t('PI.BuyerService') : t('PI.SupplierService')}
          </small>
          {renderLink()}
        </div>
        {(isPIService || isSubscriptionService) && userRole !== UserRoleType.BUYER ? (
          <LinkItem
            isTabletSize={isTabletSize}
            elementID={`${elementID}-a-sc`}
            onClick={() => CommonHelper.navigateToUrl(url)}
            label="Supplier Connect"
            logo={PTVNLogo}
          />
        ) : (
          <Dropdown.Item href={urljoin(PageRoute.PI)}>
            <span className="icon-lg-insights" style={{ marginLeft: '-22px' }}></span>
            <span className="ml-4px nowrap">PI</span>
          </Dropdown.Item>
        )}
        {userRole !== UserRoleType.ADMIN && (
          <>
            <div>
              {!!getLoginAsList() && (
                <small className="pl-2">{t('Layout.LoginAs.Label.BuyerPortal')}</small>
              )}
              {getLoginAsList()?.map((l, i) => (
                <div
                  key={`log-in-as-${i}`}
                  id="test1"
                  className="dropdown-item pl-2"
                  onClick={() => {
                    GA4Helper.event(
                      GA4TrackConstant.Category.OutboundNavigation,
                      GA4TrackConstant.Action.ProfileBtnClick,
                      l.label,
                    );
                    onClickLoginAs(l.loginUrl);
                  }}
                >
                  <img className="img-login-as" src={l.logo} />
                  <span className="span-login-as ml-4px nowrap">{l.label}</span>
                </div>
              ))}
            </div>
          </>
        )}
      </Dropdown.Menu>
    </Dropdown>
  ) : (
    <></>
  );
}

export const useAppSwitcher = (isTabletSize: boolean) => {
  const elementID = 'app-switcher';
  const { push } = useModalStack();

  const [retryCount, setRetryCount] = useState<number>(0);
  const [tenantID, setTenantID] = useState<string>();

  const [loadProviderIdp, { data: graphQLProviderIdp }] = useProviderIdpLazyQuery({
    client: GatewayGraphQLClient,
    fetchPolicy: 'network-only',
    notifyOnNetworkStatusChange: true,
    variables: {
      tenantID: tenantID!,
    },
  });

  useEffect(() => {
    const tenantID = AuthHelper.base64Decoder(Cookies.get(CookieName.TENANT_ENTITY) || '');
    tenantID && setTenantID(tenantID);
  }, []);

  useEffect(() => {
    if (tenantID) {
      loadProviderIdp();
    }
  }, [tenantID]);

  const redirectToPrevSite = (site?: string) => {
    if (tenantID === 'admin') {
      window.location.assign(APIConstant.admin.redirect);
    } else if (tenantID === 'sww') {
      switch (site) {
        case 'sww':
          window.location.assign(APIConstant.supplierConnect.redirect);
          break;
        case 'sc':
          window.location.assign(APIConstant.supplierConnect.mainPage);
          break;
      }
    } else {
      const providerGroup = graphQLProviderIdp?.provider?.providerGroup!;
      IntegrationClient.getAuthCode(tenantID!).subscribe(
        (res) => {
          const authCodeEncrypted = CommonHelper.base64Encoder(
            AES.encrypt(res.data.authCode, environment.cookieKey).toString(),
          );
          if (providerGroup === 'ep' || providerGroup === 'op') {
            Cookies.set(CookieName.AUTH_CODE, authCodeEncrypted);
            window.location.assign(APIConstant.ep.redirect);
          } else if (providerGroup === 'oneplanet') {
            const url = APIConstant.cookieAgent.setCookie
              .replace('{cookie}', authCodeEncrypted)
              .replace('{redirectUrl}', APIConstant.oneplanet.redirect);
            window.location.assign(url);
          }
        },
        (err) => {
          console.error('unable to get UAA Auth Code.', err);
          push(SomethingWentWrongModal, {
            onSubmit: () => {
              if (retryCount > 3) {
                setRetryCount(0);
              } else {
                setRetryCount(retryCount + 1);
                redirectToPrevSite(site);
              }
            },
          });
        },
      );
    }
  };

  const renderLink = () => {
    let link;
    const providerGroup = graphQLProviderIdp?.provider?.providerGroup!;
    if (tenantID === 'admin') {
      link = (
        <LinkItem
          isTabletSize={isTabletSize}
          elementID={`${elementID}-a-admin`}
          onClick={redirectToPrevSite}
          label="Admin Site"
          logo={PTVNLogo}
        />
      );
    } else {
      switch (providerGroup) {
        case 'sww':
          link = (
            <>
              <LinkItem
                isTabletSize={isTabletSize}
                elementID={`${elementID}-a-sww`}
                onClick={() => redirectToPrevSite('sww')}
                label="Supplier Web Work"
                logo={SWWLogo}
              />
              <LinkItem
                isTabletSize={isTabletSize}
                elementID={`${elementID}-a-sc`}
                onClick={() => redirectToPrevSite('sc')}
                label="Supplier Connect"
                logo={PTVNLogo}
              />
            </>
          );
          break;
        case 'ep':
          link = (
            <LinkItem
              isTabletSize={isTabletSize}
              elementID={`${elementID}-a-ep`}
              onClick={redirectToPrevSite}
              label="e-Procurement"
              logo={EPLogo}
            />
          );
          break;
        case 'op':
          link = (
            <LinkItem
              isTabletSize={isTabletSize}
              elementID={`${elementID}-a-op`}
              onClick={redirectToPrevSite}
              label="Online Purchasing"
              logo={OPLogo}
            />
          );
          break;
        case 'oneplanet':
          link = (
            <LinkItem
              isTabletSize={isTabletSize}
              elementID={`${elementID}-a-oneplanet`}
              onClick={redirectToPrevSite}
              label="Oneplanet"
              logo={OnePlanetLogo}
            />
          );
          break;
        default:
          link = <></>;
      }
    }
    return link;
  };

  return { tenantID, graphQLProviderIdp, renderLink, redirectToPrevSite, elementID };
};

interface ILinkItemProps {
  elementID: string;
  logo: string;
  label: string;
  onClick: () => void;
  isTabletSize: boolean;
}

function LinkItem(props: ILinkItemProps) {
  const { elementID, logo, label, onClick, isTabletSize } = props;
  return isTabletSize ? (
    <li>
      <a id={elementID} onClick={onClick}>
        <img src={logo} />
        <span>{label}</span>
      </a>
    </li>
  ) : (
    <Dropdown.Item
      id={elementID}
      as="a"
      onClick={() => {
        GA4Helper.event(
          GA4TrackConstant.Category.OutboundNavigation,
          GA4TrackConstant.Action.GridBtnClick,
          label,
        );
        onClick();
      }}
    >
      <img src={logo} />
      <span className="ml-4px nowrap">{label}</span>
    </Dropdown.Item>
  );
}
